// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-form {
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 10px;
  width: 35vw;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.review-form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.review-form-textarea {
  width: 30vw;
  height: 150px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 10px;
}

.review-form-rating {
  padding: 10px;
}

.review-form-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.review-form-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
}

.review-form-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/ReviewForm.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".review-form {\n  background-color: #ffffff;\n  border: 1px solid #ccc;\n  border-radius: 15px;\n  padding: 10px;\n  width: 35vw;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.review-form-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.review-form-textarea {\n  width: 30vw;\n  height: 150px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  padding: 5px;\n  margin-bottom: 10px;\n}\n\n.review-form-rating {\n  padding: 10px;\n}\n\n.review-form-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.review-form-button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n}\n\n.review-form-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
